module.exports = __webpack_public_path__ + "img/jeffrey-hamilton-JtVyK2Sej2I-unsplash.ec8fef48.jpg";